<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-row
      v-if="$route.name !== 'temps-saisie'"
      no-gutters
    >
      <v-fade-transition mode="out-in">
        <v-col
          cols="12"
          class="ma-0 pa-0"
        >
          <router-view />
        </v-col>
      </v-fade-transition>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
      >
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <MainTitle
                title="Saisie des temps"
                icon="mdi-calendar-clock"
                :loading="loading"
              />
            </v-col>
            <v-col
              cols="12"
              class="mt-3"
            >
              <v-card>
                <v-card-text class="text-center ma-0 pa-1">
                  <v-dialog
                    v-model="modalDate"
                    :return-value="currentDay"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-row
                        no-gutters
                        align="center"
                      >
                        <v-col
                          cols="12"
                          md="4"
                          class="hidden-sm-and-down ma-0 pa-0 text-left"
                        >
                          <v-hover v-slot:default="{ hover }">
                            <v-btn
                              small
                              class="ml-1"
                              :color="hover?'blue':null"
                              :disabled="loading"
                              @click="previousDay"
                            >
                              <v-icon left>
                                mdi-chevron-left
                              </v-icon>
                              <span class="hidden-sm-and-down">{{ textPreviousDay }}</span>
                            </v-btn>
                          </v-hover>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          sm="12"
                          class="text-center ma-0 pa-0"
                        >
                          <v-text-field
                            v-model="currentDayFr"
                            :disabled="loading"
                            prepend-icon="mdi-calendar-range"
                            readonly
                            :full-width="false"
                            hide-details
                            class="ma-0 pa-0"
                            v-on="on"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="hidden-sm-and-down ma-0 pa-0 text-right"
                        >
                          <v-hover v-slot:default="{ hover }">
                            <v-btn
                              small
                              class="mr-1"
                              :color="hover?'blue':null"
                              :disabled="loading"
                              @click="nextDay"
                            >
                              <span class="hidden-sm-and-down">{{ textNextDay }}</span>
                              <v-icon right>
                                mdi-chevron-right
                              </v-icon>
                            </v-btn>
                          </v-hover>
                        </v-col>
                      </v-row>
                    </template>
                    <v-date-picker
                      v-model="currentDay"
                      scrollable
                      first-day-of-week="1"
                      :disabled="loading"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modalDate = false"
                      >
                        Annuler
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              v-if="!loading"
              cols="12"
              class="mt-3"
            >
              <v-form
                ref="form"
                lazy-validation
              >
                <v-row
                  v-if="clients.length"
                  no-gutters
                  class="pt-3 pb-3"
                >
                  <v-col
                    cols="auto"
                  >
                    Trier les dossiers de client par...
                  </v-col>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-1 subtitle-2 font-weight-regular"
                  >
                    Numéro de dossier
                  </v-col>
                  <v-col
                    cols="auto"
                  >
                    <v-switch
                      v-model="trierParNumeroDossier"
                      color="grey"
                      class="ma-0 pa-0"
                      hide-details
                      dense
                    />
                  </v-col>
                  <v-col
                    cols="auto"
                    class="subtitle-2 font-weight-regular"
                  >
                    Nom du dossier
                  </v-col>
                </v-row>

                <v-card
                  v-for="client in clients"
                  :key="client.clientId"
                  class="mt-4 mb-6 elevation-3"
                >
                  <v-card-title :class="(client.erreur ? 'orange lighten-4':client.dossiers.length ? 'light-green lighten-4':'grey lighten-2') + ' elevation-2'">
                    <v-row no-gutters>
                      <v-col :cols="$vuetify.breakpoint.smAndDown?12:10">
                        <v-icon
                          :color="client.couleur ? client.couleur : 'grey'"
                          left
                          size="30"
                        >
                          mdi-briefcase-account
                        </v-icon>

                        <v-icon
                          v-if="client.erreur && $vuetify.breakpoint.smAndDown"
                          large
                          color="orange"
                        >
                          mdi-alert
                        </v-icon>
                        {{ client.libelle }}
                        <span v-if="$vuetify.breakpoint.smAndDown &&client.duree">({{ client.duree | floatToHeureHumain }})</span>
                      </v-col>
                      <v-col
                        v-if="!$vuetify.breakpoint.smAndDown"
                        cols="2"
                        class="text-right"
                      >
                        <v-icon
                          v-if="client.erreur"
                          large
                          color="orange"
                        >
                          mdi-alert
                        </v-icon>
                        <span v-else>{{ client.duree | floatToHeureHumain }}</span>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mt-3">
                    <v-col
                      v-if="!client.dossiers.length"
                      cols="12"
                      class="text-center grey--text font-italic"
                    >
                      Aucun dossier présent pour ce client. Veuillez en ajouter un dans la configuration pour pouvoir ajouter des heures.
                    </v-col>
                    <v-row
                      v-for="(dossier, dossierIndex) in client.dossiers"
                      :key="dossier.dossierId"
                      no-gutters
                      align="start"
                      justify="start"
                    >
                      <v-col
                        cols="12"
                      >
                        <v-icon
                          :color="dossier.couleur ? dossier.couleur : 'grey'"
                          size="22"
                          left
                        >
                          mdi-folder
                        </v-icon>

                        <v-icon
                          v-if="dossier.erreur"
                          color="orange"
                          left
                        >
                          mdi-alert
                        </v-icon>
                        <span class="font-weight-black">{{ dossier.libelle }}</span> <span class="grey--text caption" v-if="dossier.numero">({{dossier.numero}})</span>
                        <span v-if="$vuetify.breakpoint.smAndDown &&!dossier.erreur && dossier.duree"> {{ dossier.duree | floatToHeureHumain }}</span>
                      </v-col>
                      <v-col
                        v-if="!dossier.plages"
                        cols="12"
                        class="text-center grey--text font-italic pa-0 ma-0"
                      >
                        Aucun travail effectué concernant {{ dossier.libelle }} pour {{ client.libelle }}
                      </v-col>
                      <v-col
                        cols="12"
                        :class="$vuetify.breakpoint.xs ? 'pt-3': 'pt-3 pl-5'"
                      >
                        <v-row
                          v-for="(plage, plageIndex) in dossier.plages"
                          :key="plage.plageid"
                          no-gutters
                          align="start"
                        >
                          <v-col
                            cols="12"
                            sm="12"
                            md="5"
                          >
                            <v-textarea
                              v-model="plage.description"
                              class="ma-1"
                              dense
                              rows="1"
                              outlined
                              auto-grow
                              label="Observations"
                              :autofocus="plage.isNew"
                              hide-details="auto"
                              :loading="plage.loading"
                              :disabled="plage.remove"
                              @blur="blurDescription(plage, client.clientId, dossier.dossierId, plage.plageId)"
                              @keyup.tab="saveHeures(client.clientId, dossier.dossierId, plage.plageId)"
                            />
                          </v-col>
                          <v-col
                            cols="6"
                            sm="6"
                            md="2"
                          >
                            <v-text-field
                              v-model="plage.debut"
                              class="ma-1"
                              dense
                              outlined
                              label="Heure de début"
                              hide-details="auto"
                              :rules="timeFieldRules('debut')"
                              :loading="plage.loading"
                              :disabled="plage.remove"
                              @keyup="updateViewRecords(client.clientId, dossier.dossierId, plage.plageId)"
                              @blur="onHeuresBlur(client.clientId, dossier.dossierId, plage.plageId)"
                              @change="saveHeures(client.clientId, dossier.dossierId, plage.plageId)"
                            />
                          </v-col>
                          <v-col
                            cols="6"
                            sm="6"
                            md="2"
                          >
                            <v-menu
                              v-model="menuAutoPlageFin[plage.plageId]"
                              offset-y
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="plage.fin"
                                  class="ma-1"
                                  dense
                                  outlined
                                  label="Heure de fin"
                                  :rules="timeFieldRules('fin')"
                                  hide-details="auto"
                                  :append-icon="heureIsValid(plage.debut)?'mdi-auto-fix':undefined"
                                  :loading="plage.loading"
                                  :disabled="plage.remove"
                                  @keyup="updateViewRecords(client.clientId, dossier.dossierId, plage.plageId)"
                                  @blur="onHeuresBlur(client.clientId, dossier.dossierId, plage.plageId)"
                                  @click:append="showMenuAutoCompleteFinPlage(plage)"
                                  @change="saveHeures(client.clientId, dossier.dossierId, plage.plageId)"
                                />
                              </template>
                              <v-list dense>
                                <v-subheader class="font-weight-bold font-italic">
                                  Calcul automatique de fin
                                </v-subheader>
                                <v-list-item
                                  v-for="minute in [5, 10, 15, 20, 30, 45]"
                                  :key="'min-'+minute"
                                  @click="setHeureFinCalculle(plage, minute/60)"
                                >
                                  <v-list-item-title>{{ minute }} minute{{ minute===1?'':'s' }} <span class="font-weight-thin">(Soit {{ heureNumeriqueToHumain(calculateFin(plage.debut, minute/60)) }})</span></v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  v-for="heure in [1,1.5, 2,2.5, 3, 3.5, 4,5,6,7]"
                                  :key="'heure-'+heure"
                                  @click="setHeureFinCalculle(plage, heure)"
                                >
                                  <v-list-item-title>{{ Math.floor(heure) }} heure{{ Math.floor(heure)===1?'':'s' }} {{ Math.floor(heure)!=heure?Math.floor((heure-Math.floor(heure))*60):'' }} <span class="font-weight-thin">(Soit {{ heureNumeriqueToHumain(calculateFin(plage.debut, heure)) }})</span></v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="6"
                            sm="6"
                            md="2"
                          >
                            <v-select
                              v-model="plage.tarifHoraire"
                              :items="tarifsHoraires[client.clientId]"
                              :loading="plage.loading"
                              :disabled="plage.remove"
                              outlined
                              label="Tarif"
                              dense
                              class="ma-1"
                              item-value="tarifId"
                              item-text="libelleItem"
                              height="30"
                              :rules="[(value) => !!value || 'Tarif obligatoire']"
                              @input="onChangeTarifHoraire(client.clientId, dossier.dossierId, plage.plageId)"
                              @change="onChangeTarifHoraire(client.clientId, dossier.dossierId, plage.plageId)"
                            >
                              <template v-slot:selection=" { item }">
                                <span :class="'text-no-wrap '">{{ item.tarif }} €/h</span>
                              </template>
                              <template v-slot:label>
                                <span>Tarif</span>
                              </template>
                            </v-select>
                          </v-col>
                          <v-col
                            cols="6"
                            sm="6"
                            md="1"
                            class="text-right"
                          >
                            <v-hover v-slot:default="{ hover }">
                              <v-btn
                                small
                                :color="hover?'red':null"
                                :loading="plage.remove"
                                :disabled="plage.loading"
                                @click="removePlage(client.clientId, dossier.dossierId, plage.plageId)"
                              >
                                <v-icon :left="$vuetify.breakpoint.smAndDown">
                                  mdi-trash-can
                                </v-icon> <span v-if="$vuetify.breakpoint.smAndDown"> Supprimer</span>
                              </v-btn>
                            </v-hover>
                          </v-col>

                          <v-divider
                            :class="dossier.plages.length-1 !== plageIndex ? 'mb-4 mt-2' : 'mb-1 mt-2'"
                          />
                        </v-row>
                        <v-row no-gutters>
                          <v-col
                            cols="12"
                            class="text-right"
                          >
                            <v-hover v-slot:default="{ hover }">
                              <v-btn
                                small
                                :color="hover?'green':null"
                                @click="addPlage(client.clientId, dossier.dossierId)"
                              >
                                <v-icon left>
                                  mdi-plus
                                </v-icon> Ajouter une plage
                              </v-btn>
                            </v-hover>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-divider
                        v-if="client.dossiers.length-1 !== dossierIndex"
                        class="mb-3"
                      />
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import MainTitle from '../Common/MainTitle'

export default {
  components: { MainTitle },
  filters: {
    floatToHeureHumain (valeur) {
      if (!valeur) {
        return null
      }
      let heure = Math.floor(valeur)
      let minute = Math.floor((valeur - heure) * 60)

      return (heure < 10 ? '0' + heure : heure) + 'h' + (minute < 10 ? '0' + minute : minute)
    }
  },
  data: () => {
    return {
      trierParNumeroDossier: true,
      intervalCheckForm: null,
      menuAutoPlageFin: {},
      updateVue: 1,
      currentDay: null,
      modalDate: false,
      timeFieldRules: (field) => [
        (value) => {
          if (!value || value === '') {
            return field === 'debut' ? 'Heure de début obligatoire' : 'Heure de fin obligatoire'
          }
          if (value.match(/^([0-1]?[0-9]|2[0-3])(:|h|H)([0-5][0-9])?$/)) {
            return true
          }
          if (value.match(/^([0-1]?[0-9]|2[0-3])(\.)\d+$/)) {
            return true
          }
          return 'Format invalide'
        }
      ]
    }
  },
  computed: {
    ...mapState('worktools/temps', ['tempsRetrieveState', 'tempsRetrieveRecords']),
    ...mapState('worktools/tarifHoraire', ['listTarifsState', 'listTarifsRecords']),
    ...mapGetters('user', ['hasPermission']),
    loading () {
      return this.tempsRetrieveState === 'in-progress' || this.listTarifsState === 'in-progress'
    },
    tarifsHoraires () {
      if (this.loading) {
        return {}
      }
      let result = {}
      this.listTarifsRecords.tarifs.forEach(record => {
        if (!result[record.clientId]) {
          result[record.clientId] = []
        }
        let categorie = this.listTarifsRecords.categories.find(categorie => categorie.categorieId === record.categorieId)
        if (categorie && (record.tarif || record.tarif === 0)) {
          result[record.clientId].push({
            libelleItem: categorie.libelle + ' : ' + record.tarif + ' €',
            tarif: record.tarif,
            tarifId: record.categorieId
          })
        }
      })
      return result
    },
    clients () {
      if (this.updateVue < 0) { // Force update... Todo why not update ?
        return
      }
      if (this.loading) {
        return []
      }
      let champ = this.trierParNumeroDossier ? 'numero' : 'libelle'
      let records = this.tempsRetrieveRecords && this.tempsRetrieveRecords.clients ? this.tempsRetrieveRecords.clients : []
      return records.map(row => {
        row.dossiers = row.dossiers.sort((a, b) => (a[champ] > b[champ]) ? 1 : -1)
        return row
      })
    },
    currentDayFr () {
      if (!this.currentDay) {
        return null
      }
      let dateFr = this.$moment(this.currentDay).format('dddd D MMMM YYYY')
      return dateFr ? (dateFr[0].toUpperCase() + dateFr.slice(1)) : null
    },
    textPreviousDay () {
      return this.humanDate(this.$moment(this.currentDay).add(-1, 'day'))
    },
    textNextDay () {
      return this.humanDate(this.$moment(this.currentDay).add(1, 'day'))
    }
  },
  watch: {
    currentDay (value) {
      this.modalDate = false
      if (this.$route.name !== 'temps-saisie') {
        return
      }
      let newDay = value ? this.$moment(value).format('YYYY-MM-DD') : null
      if (this.$route.query.day === newDay) {
        return
      }
      this.$router.replace({
        name: 'temps-saisie',
        query: {
          day: newDay
        }
      })
      this.executeQuery()
    },
    '$route' (newRoute, oldRoute) {
      if (newRoute.name !== oldRoute.name) {
        if (newRoute.query.day && newRoute.query.day !== this.currentDay) {
          this.currentDay = newRoute.query.day
        }
        this.executeQuery()
      }
    }
  },
  mounted () {
    if (!this.currentDay && this.$route.query && this.$route.query.day) {
      this.currentDay = this.$route.query.day
    }
    if (!this.currentDay) {
      this.currentDay = this.$moment().format('YYYY-MM-DD')
    }
    this.executeQuery()
    this.listAllTarifs()
  },
  destroyed () {
    if (this.intervalCheckForm) {
      clearInterval(this.intervalCheckForm)
    }
  },
  methods: {
    ...mapActions('worktools/tarifHoraire', ['listAllTarifs']),
    ...mapActions('worktools/temps', ['retrieveTempsForADay', 'savePeriodeOfDayForAClientDossier', 'removePeriodeOfDayForAClientDossier']),
    ...mapMutations('worktools/temps', ['addEmptyPlage', 'updatePlageRecords', 'removePlageRecord', 'setLoadingPlageRecord', 'removePlageRecordState']),
    executeQuery () {
      this.retrieveTempsForADay({
        day: this.currentDay
      }).then(() => {
        this.$nextTick(() => {
          this.clients.forEach(client => {
            client.dossiers && client.dossiers.forEach(dossier => {
              dossier.plages && dossier.plages.forEach(plage => {
                this.updatePlageRecords({ clientId: client.clientId, dossierId: dossier.dossierId, plageId: plage.plageId, reformatHeure: false })
              })
            })
          })
          this.checkForm()
          this.updateView()
        })
      })
    },
    previousDay () {
      this.currentDay = this.$moment(this.currentDay).add(-1, 'day').format('YYYY-MM-DD')
    },
    nextDay () {
      this.currentDay = this.$moment(this.currentDay).add(1, 'day').format('YYYY-MM-DD')
    },
    humanDate (date) {
      if (date.format('YYYY-MM-DD') === this.$moment().add(-1, 'day').format('YYYY-MM-DD')) {
        return 'Hier'
      }
      if (date.format('YYYY-MM-DD') === this.$moment().add(1, 'day').format('YYYY-MM-DD')) {
        return 'Demain'
      }
      if (date.format('YYYY-MM-DD') === this.$moment().format('YYYY-MM-DD')) {
        return 'Aujourd\'hui'
      }
      return date.format('dddd D MMMM YYYY')
    },
    addPlage (clientId, dossierId) {
      this.addEmptyPlage({ clientId, dossierId })
      this.$nextTick(() => {
        this.$refs.form.validate()
        this.updateVue++

        let plages = this.clients.find(client => client.clientId === clientId).dossiers.find(dossier => dossier.dossierId === dossierId).plages
        let plageId = plages[plages.length - 1].plageId
        this.updatePlageRecords({ clientId, dossierId, plageId, reformatHeure: false })
      })
    },
    removePlage (clientId, dossierId, plageId) {
      this.removePlageRecordState({ clientId, dossierId, plageId, state: true })
      this.updateView()
      this.doRemovePlage(clientId, dossierId, plageId).then(() => {
        this.removePlageRecord({ clientId, dossierId, plageId })
        this.updatePlageRecords({ clientId, dossierId, plageId, reformatHeure: true })
        this.updateView()
      })
    },
    updateViewRecords (clientId, dossierId, plageId) {
      this.updatePlageRecords({ clientId, dossierId, plageId, reformatHeure: false })
      this.$refs.form.validate()
      this.updateView()
    },
    reformatHeures (clientId, dossierId, plageId) {
      this.updatePlageRecords({ clientId, dossierId, plageId, reformatHeure: true })
      this.$refs.form.validate()
      this.updateView()
    },
    updateView () {
      this.updateVue++
    },
    heureIsValid (value) {
      if (!value || value === '') {
        return false
      }
      if (value.match(/^([0-1]?[0-9]|2[0-3])(:|h|H)([0-5][0-9])?$/)) {
        return true
      }
      if (value.match(/^([0-1]?[0-9]|2[0-3])(\.)\d+$/)) {
        return true
      }
      return false
    },
    heureToFloat (value) {
      if (!this.heureIsValid(value)) {
        return null
      }
      let formatHeure = value.match(/^([0-1]?[0-9]|2[0-3])(:|h|H)([0-5][0-9])?$/)
      let formatNumerique = value.match(/^([0-1]?[0-9]|2[0-3])(\.)(\d+)$/)
      if (formatHeure) {
        return parseInt(formatHeure[1]) + (formatHeure[3] ? parseInt(formatHeure[3]) : 0) / 60
      }
      if (formatNumerique) {
        return parseFloat(value)
      }
      return null
    },
    heureNumeriqueToHumain (valeur) {
      if (valeur === null) {
        return null
      }
      let heure = Math.floor(valeur)
      let minute = Math.floor((valeur - heure) * 60)

      return (heure < 10 ? '0' + heure : heure) + 'h' + (minute < 10 ? '0' + minute : minute)
    },
    calculateFin (value, heureToAdd) {
      let start = this.heureToFloat(value)
      if (start === null) {
        return null
      }
      return start + heureToAdd
    },
    showMenuAutoCompleteFinPlage (plage) {
      this.updateView()
      if (!this.heureIsValid(plage.debut)) {
        return
      }
      this.$set(this.menuAutoPlageFin, plage.plageId, !this.menuAutoPlageFin[plage.plageId])
      this.updateView()
    },
    setHeureFinCalculle (plage, heure) {
      plage.fin = this.heureNumeriqueToHumain(this.calculateFin(plage.debut, heure))
      this.updateView()
    },
    onHeuresBlur (clientId, dossierId, plageId) {
      this.reformatHeures(clientId, dossierId, plageId)
      this.$nextTick(() => this.saveHeures(clientId, dossierId, plageId))
    },
    saveHeures (clientId, dossierId, plageId) {
      this.setLoadingPlageRecord({ clientId, dossierId, plageId, loading: true })
      this.updateView()
      let plage
      try {
        plage = this.clients.find(client => client.clientId === clientId).dossiers.find(dossier => dossier.dossierId === dossierId).plages.find(plage => plage.plageId === plageId)
      } catch (error) {
        console && console.error(error)
        return
      }
      if (!plage) {
        return
      }
      this.doSavePlage(clientId, dossierId, plageId, plage.debut, plage.fin, plage.description, plage.tarifHoraire ? plage.tarifHoraire : null).then(() => {
        this.setLoadingPlageRecord({ clientId, dossierId, plageId, loading: false })
        this.updateView()
      })
    },
    doSavePlage (clientId, dossierId, plageId, debut, fin, description, tarifHoraire) {
      return this.savePeriodeOfDayForAClientDossier({
        day: this.currentDay,
        clientId,
        dossierId,
        plageId,
        debut,
        fin,
        description,
        tarifHoraire
      })
    },
    doRemovePlage (clientId, dossierId, plageId) {
      return this.removePeriodeOfDayForAClientDossier({
        day: this.currentDay,
        clientId,
        dossierId,
        plageId
      })
    },
    blurDescription (plage, clientId, dossierId, plageId) {
      if (plage.description) {
        plage.description = plage.description.trim()
      }
      this.saveHeures(clientId, dossierId, plageId)
    },
    checkForm () {
      if (this.$refs.form) {
        this.$refs.form.validate()
      } else {
        this.intervalCheckForm = setTimeout(() => this.checkForm(), 1000)
      }
    },
    onChangeTarifHoraire (clientId, dossierId, plageId) {
      this.updateViewRecords(clientId, dossierId, plageId)
      this.saveHeures(clientId, dossierId, plageId)
    }
  }
}
</script>
